/**
 * @module views\mdl\meter
 */
import Component from "vue-class-component";
import { Mixins } from "vue-property-decorator";
import DependedStructure from "../dependedStructure/dependedStructure";
import MeterTypeNavigation from "@/businessComponents/mdl/meterTypeNavigation/meterTypeNavigation";

@Component({
  components: {
    MeterTypeNavigation
  }
})
export default class Meter extends Mixins(DependedStructure) {
  protected module = "mes.business.mdl.meter.service";
  protected cls = "MeterService";
  // protected argsQuery = { structure_cd: "", keywords: "", meter_type: "" };

  private get StruCd() {
    let cd = "";
    if (this.selectedStructure) {
      cd = this.selectedStructure.data.Cd;
    }
    return cd;
  }

  private onSelectedType(type: IndexObject | null) {
    console.log(type);
    let id = "";
    if (type) {
      id = type.Id;
      this.itemTemplate.MeterTypeId = id;
      this.itemTemplate.MeterTypeName = type.Name;
    } else {
      this.itemTemplate.MeterTypeId = "";
      this.itemTemplate.MeterTypeName = "";
    }

    this.$set(this.argsQuery, "meter_type", id);
  }

  // /**
  //  * 当结构节点改变时
  //  */
  // @Watch("structure")
  // private observeStructure() {
  //   if (this.structure && this.structure.data) {
  //     this.argsQuery.structure_cd = this.structure.data.Cd;
  //     this.template.StructureId = this.structure.key;
  //     this.template.StructureName = this.structure.data.Name;
  //     if (this.table) {
  //       this.table.query(this.argsQuery);
  //     }
  //   }
  // }

  // private changeStructure(model, node: TreeNode<string, IndexObject>) {
  //   if (node) {
  //     model.StructureId = node.key;
  //     model.StructureName = node.data.Name;
  //     console.log(model);
  //   }

  // }

  // private getStruCount(struId) {
  //   let s = this.struCount[struId];
  //   if (s) {
  //     return s.value;
  //   }
  //   return 0;
  // }

  // private getTypeCount(typeId) {
  //   let s = this.typeCounts[typeId];
  //   return s;
  // }

  // private get table() {
  //   return this.$refs.table as GhTablePage;
  // }

  // private setMeterType(val: IndexObject | null, toggle) {
  //   if (toggle) {
  //     toggle();
  //   }
  //   this.selecteMeterType = val;
  //   if (this.selecteMeterType) {
  //     this.template.MeterTypeId = this.selecteMeterType.Id;
  //     this.template.MeterTypeName = this.selecteMeterType.Name;
  //     this.argsQuery.meter_type = this.selecteMeterType.Id;
  //   } else {
  //     this.argsQuery.meter_type = "";
  //   }

  //   if (this.table) {
  //     this.table.query(this.argsQuery);
  //   }
  // }

  // private async statisticStruCount() {
  //   try {
  //     let result = await this.svStruCount.invokeAsyn();
  //     if (result.data.isSuccess) {
  //       this.struCount = result.data.data;
  //     } else {
  //       this.struCount = {};
  //     }
  //   } catch (error) {
  //     this.struCount = {};
  //   }
  // }

  // private async statisticTypeCount() {
  //   let args = { stru_cd: "", keywords: this.argsQuery.keywords };
  //   if (this.structure) {
  //     args.stru_cd = this.structure.data.Cd;
  //   }
  //   try {
  //     let result = await this.svTypeCount.invokeAsyn(args);
  //     if (result.data.isSuccess) {
  //       this.typeCounts = result.data.data;
  //       let sum = 0;
  //       for (const key in this.typeCounts) {
  //         if (this.typeCounts.hasOwnProperty(key)) {
  //           const element: number = this.typeCounts[key];

  //           sum += element;
  //         }
  //       }
  //       this.typeCounts["-1"] = sum;
  //     } else {
  //       this.typeCounts = {};
  //     }
  //   } catch (error) {
  //     this.typeCounts = {};
  //   }
  // }

  // private tabs: IGhTab[] = [{ show: true, drawer: true, title: "仪表维护" }];
  // private structure: TreeNode<string, any> | any = null;
  // private argsQuery = { keywords: "", structure_cd: "", meter_type: "" };
  // private struCount = {};
  // private typeCounts = {};
  // private selecteMeterType: IndexObject | null = null;

  // private svStruCount: MethodService = new MethodService(
  //   "mes.business.mdl.meter.service",
  //   "MeterService",
  //   "statistic_stru_count"
  // );
  // private svTypeCount: MethodService = new MethodService(
  //   "mes.business.mdl.meter.service",
  //   "MeterService",
  //   "statistic_type_count"
  // );
}
